import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ErrorIcon } from "../icons/ErrorIcon";
import Header from "./Header";
import PoweredBy from "./PoweredBy";
function Error() {
  const { error } = useSelector((store) => store.verification);
  const { t } = useTranslation();

  return (
    <div className="flex flex-col p-4 gap-4 w-full h-full">
      <Header />
      <div className="flex flex-col h-full justify-between">
        <div className="flex flex-col flex-grow items-center justify-center gap-4">
          <ErrorIcon height={100} width={100} />
          <div className="mb-5 text-center">
            <div className="heading text-lg">{t("common.error.heading")}</div>
            <div className="text-sm" style={{color: "var(--urtentic-sdk-subtitle, #737373)"}}>{error}</div>
          </div>
        </div>
        <div className="flex flex-col justify-end">
          <PoweredBy />
        </div>
      </div>
    </div>
  );
}

export default Error;
